import { memo } from 'react';

import useMedias from '@Hooks/useMedias';
import Tab from '@Pages/PageExpressDesign/elements/Tab';
import styles from './TariffInformation.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { TariffData, TariffTabData } from '@Pages/PageExpressDesign/type';
import type { TabData } from '@Pages/PageExpressDesign/elements/Tab';

interface TariffInformationProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  tariff: TariffData;
  tabs: TabData[];
  selectedTab?: TariffTabData;
  onChangeTab?: (newTab: TabData) => void;
}

const TariffInformation: FC<TariffInformationProps> = (props) => {
  const { tariff, tabs, selectedTab, onChangeTab, ...restProps } = props;
  const { isDesktop } = useMedias();

  return (
    <div {...restProps}>
      <div className={styles.name}>{tariff.title}</div>
      <div className={styles.period}>{tariff.period}</div>
      <div className={styles.tabs}>
        {tabs.map((tab) => {
          return (
            <Tab
              key={tab.id}
              item={tab}
              onChangeTab={onChangeTab}
              idSelectedTab={selectedTab.id.toString()}
              isHiddenTooltip={isDesktop}
              tooltip={tab.tooltip}
            />
          );
        })}
      </div>
      {isDesktop && <div className={styles.clarification}>*{selectedTab.tooltip}</div>}
    </div>
  );
};

export default memo(TariffInformation);
